import _ from 'lodash';
import { OrderedMap, fromJS, Map } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';

export const createDefaultState = () =>
  fromJS({
    ppsis: OrderedMap(),
    globalStatusPpsis: Map(),
    isFetching: false,
    isInDraftFetched: false,
    fetchError: null,
    isSaving: false,
    saveError: null,
    lastSavedPpsiId: null,
    isApproving: false,
    approveError: null,
    isSendingForReview: false,
    sendReviewError: null,
    isPublishing: false,
    publishError: null,
    isUnpublishing: false,
    unpublishError: null,
    isCreatingDraft: false,
    createDraftError: null,
    ismarkingAsUptoDate: false,
    markAsUptoDateError: null,
    isImportingIfoodUpdate: false,
    importingIfoodUpdateError: null,
    isImportingGlobalUpdate: false,
    importingGlobalUpdateError: null,
    isdiscardingDraft: false,
    discardDraftError: null,
    globalApprovalPpsis: Map(),
    reviewPpsis: Map(),
    ppsisReviewSummary: Map(),
    isFetchingReviewSummary: false,
    reviewSummaryError: null,
    isglobalApproving: false,
    globalApproveError: null,
    isglobalRejecting: false,
    globalRejectError: null,
    isFetchingGlobalStatus: false,
    globalStatusError: null,
    totalRangeReport: Map(),
    isFetchingRangeReport: false,
    rangeReportError: null,
    totalEngagementReport: Map(),
    isFetchingEngagementReport: false,
    engagementReportError: null,
    totalEngagementReportMarketList: Map(),
    isFetchingEngagementReportMarketList: false,
    engagementReportMarketListError: null,
    fetchDeleteError: null,
    varaintPpsis: Map(),
    isFetchingVariant: false,
    varaintPpsisError: null,
    isBomReportUploading: false,
    bomReportUploadError: null,
    bomReportUploadSuccess: null,
    globalPublishedPpsisNir: Map(),
    globalPublishedPpiIfs: Map(),
    marketDishLogo: Map(),
    isEnableAvailablity: false,
    paRaNirError: false,
    piaProductAreas: Map(),
    updateGlobalPpsis: null,
    updatePpsis: Map(),
    isFetchingCopyLocal: false,
    publishedUnpublishedPpsis: Map(),
    show: false
  });

function normalizeEnrichmentData(enrichmentData) {
  if (!enrichmentData || !enrichmentData.referencedIFoodData) {
    return enrichmentData;
  }
  const ingredientEntries =
    enrichmentData.referencedIFoodData.referencedIngredientEntities;
  // const normalizedEnrichmentData = _.omit(
  //   enrichmentData,
  //   'referencedIFoodData.referencedIngredientEntities'
  // );
  const normalizedEnrichmentData = enrichmentData;
  normalizedEnrichmentData.ingredientEntryIds = ingredientEntries.map(
    entry => entry.id
  );
  return normalizedEnrichmentData;
}

function normalizePpsiData(ppsi) {
  const normalizedPpsi = _.cloneDeep(ppsi);
  normalizedPpsi.inProgressPpsiEnrichmentData = normalizeEnrichmentData(
    ppsi.inProgressPpsiEnrichmentData
  );
  normalizedPpsi.publishedPpsiEnrichmentData = normalizeEnrichmentData(
    ppsi.publishedPpsiEnrichmentData
  );
  return normalizedPpsi;
}

// Transform list of objects to object with the ids as keys
const mergePpsis = (state, ppsis) =>
  state
    .get('ppsis')
    .merge(
      ppsis.reduce(
        (map, ppsi) => map.set(ppsi.id, fromJS(normalizePpsiData(ppsi))),
        OrderedMap()
      )
    );

const deletePpsis = (state, payload) => {
  let getPpsis = state.get('ppsis');
  payload.forEach(id => {
    getPpsis = getPpsis.delete(id);
  });
  return getPpsis;
};

const mergeReviewPpsis = (state, ppsis) =>
  state
    .get('ppsisReviewSummary')
    .merge(
      ppsis.reduce(
        (map, ppsi) => map.set(ppsi.id, fromJS(normalizePpsiData(ppsi))),
        OrderedMap()
      )
    );

const removePpsi = state => {
  const ppsiId = state.get('lastSavedPpsiId');
  const getPpsis = state.get('ppsis');
  const result = (getPpsis.filter(i => i.id !== ppsiId), OrderedMap());
  return result;
};

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();

    case constants.FETCH_PPSI:
    case constants.FETCH_PPSI_GLOBAL:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_PPSI_DONE:
      return state
        .set('ppsis', mergePpsis(state, [payload]))
        .set('isFetching', false)
        .set('fetchError', null);
    case constants.FETCH_PPSI_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    // For Deleting PPSI

    case constants.DELETE_PPSI:
      return state.set('isFetching', true).set('fetchDeleteError', null);
    case constants.DELETE_PPSI_DONE:
      return state
        .set('ppsis', deletePpsis(state, payload))
        .set('isFetching', false)
        .set('fetchDeleteError', null);
    case constants.DELETE_PPSI_FAIL:
      return state
        .set('isFetching', false)
        .set('fetchDeleteError', fromJS(payload));

    // CREATE VARIANT FOR PPSI

    case constants.CREATE_PPSI_VARIANT:
      return state
        .set('isFetchingVariant', true)
        .set('varaintPpsisError', null);
    case constants.CREATE_PPSI_VARIANT_DONE:
      return state
        .set('varaintPpsis', fromJS(payload))
        .set('isFetchingVariant', false)
        .set('varaintPpsisError', null);
    case constants.CREATE_PPSI_VARIANT_FAIL:
      return state
        .set('isFetchingVariant', false)
        .set('varaintPpsisError', fromJS(payload));

    case constants.FETCH_PPSIS:
      if (window.location.pathname.includes('ppsis/publishedPpsi')) {
        return state
          .set('isFetching', true)
          .set('fetchError', null)
          .set('ppsis', OrderedMap());
      }
      return state.set('isFetching', true).set('fetchError', null);

    case constants.FETCH_PPSIS_DONE:
      return state
        .set('ppsis', mergePpsis(state, payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.FETCH_PPSIS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.UPDATES_PPSIS:
      return state.set('isFetching', true).set('fetchError', null);

    case constants.UPDATES_PPSIS_DONE:
      return state
        .set('ppsis', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.UPDATES_PPSIS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.UPDATES_GLOBAL_PPSIS:
      return state.set('isFetching', true).set('fetchError', null);

    case constants.UPDATES_GLOBAL_PPSIS_DONE:
      return state
        .set('ppsis', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.UPDATES_GLOBAL_PPSIS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.FETCH_PPSIS_GLOBAL:
      return state.set('isFetching', true).set('fetchError', null);

    case constants.CREATE_PPSI:
      return state
        .set('isSaving', true)
        .set('saveError', null)
        .set('lastSavedPpsiId', null);
    case constants.CREATE_PPSI_DONE:
      return state
        .set('ppsis', mergePpsis(state, [payload]))
        .set('isSaving', false)
        .set('saveError', null)
        .set('lastSavedPpsiId', payload.id);
    case constants.CREATE_PPSI_FAIL:
      return state.set('isSaving', false).set('saveError', fromJS(payload));

    case constants.SAVE_PPSI:
      return state
        .set('isSaving', true)
        .set('saveError', null)
        .set('lastSavedPpsiId', null);
    case constants.SAVE_PPSI_DONE:
      return state
        .set('ppsis', mergePpsis(state, [payload]))
        .set('isSaving', false)
        .set('saveError', null)
        .set('lastSavedPpsiId', payload.id);
    case constants.SAVE_PPSI_FAIL:
      return state.set('isSaving', false).set('saveError', fromJS(payload));

    case constants.APPROVE_PPSI:
      return state.set('isApproving', true).set('approveError', null);
    case constants.APPROVE_PPSI_DONE:
      return state
        .set('isApproving', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.APPROVE_PPSI_FAIL:
      return state
        .set('isApproving', false)
        .set('approveError', fromJS(payload));

    case constants.PUBLISH_PPSI:
      return state.set('isPublishing', true).set('publishError', null);
    case constants.PUBLISH_PPSI_DONE:
      return state
        .set('isPublishing', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.PUBLISH_PPSI_FAIL:
      return state
        .set('isPublishing', false)
        .set('publishError', fromJS(payload));

    // IFPPSI-954 - Publish empty PPSI option for global admin;

    case constants.PUBLISH_EMPTY_PPSI:
      return state.set('isPublishing', true).set('publishError', null);
    case constants.PUBLISH_EMPTY_PPSI_DONE:
      return state
        .set('isPublishing', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.PUBLISH_EMPTY_PPSI_FAIL:
      return state
        .set('isPublishing', false)
        .set('publishError', fromJS(payload));

    case constants.UNPUBLISH_PPSI:
      return state.set('isUnpublishing', true).set('unpublishError', null);
    case constants.UNPUBLISH_PPSI_DONE:
      return state
        .set('isUnpublishing', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.UNPUBLISH_PPSI_FAIL:
      return state
        .set('isUnpublishing', false)
        .set('unpublishError', fromJS(payload));

    case constants.MARK_AS_UPTODATE_PPSI:
      return state
        .set('ismarkingAsUptoDate', true)
        .set('markAsUptoDateError', null);
    case constants.MARK_AS_UPTODATE_PPSI_DONE:
      return state
        .set('ismarkingAsUptoDate', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.MARK_AS_UPTODATE_PPSI_FAIL:
      return state
        .set('ismarkingAsUptoDate', false)
        .set('markAsUptoDateError', fromJS(payload));

    case constants.CREATE_DRAFT_PPSI:
      return state.set('isCreatingDraft', true).set('createDraftError', null);
    case constants.CREATE_DRAFT_PPSI_DONE:
      return state
        .set('ppsis', mergePpsis(state, [payload]))
        .set('isCreatingDraft', false);
    case constants.CREATE_DRAFT_PPSI_FAIL:
      return state
        .set('isCreatingDraft', false)
        .set('createDraftError', fromJS(payload));

    // IMPORT IFOOD UPDATE
    case constants.IMPORT_IFOOD_UPDATE_PPSI:
      return state
        .set('isImportingIfoodUpdate', true)
        .set('importingIfoodUpdateError', null);
    case constants.IMPORT_IFOOD_UPDATE_PPSI_DONE:
      return state
        .set('isImportingIfoodUpdate', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.IMPORT_IFOOD_UPDATE_PPSI_FAIL:
      return state
        .set('isImportingIfoodUpdate', false)
        .set('markAsUptoDateError', fromJS(payload));

    // import Global PPSI update
    case constants.IMPORT_GLOBAL_UPDATE_PPSI:
      return state
        .set('isImportingGlobalUpdate', true)
        .set('importingGlobalUpdateError', null);
    case constants.IMPORT_GLOBAL_UPDATE_PPSI_DONE:
      // console.log('IMPORT_GLOBAL_UPDATE_PPSI_DONE',payload)
      return state
        .set('isImportingGlobalUpdate', false)
        .set('ppsis', mergePpsis(state, [payload]));
    case constants.IMPORT_GLOBAL_UPDATE_PPSI_FAIL:
      return state
        .set('isImportingGlobalUpdate', false)
        .set('markAsUptoDateError', fromJS(payload));

    // PPSI discard draft
    case constants.DISCARD_DRAFT_PPSI:
      return state
        .set('isdiscardingDraft', true)
        .set('discardDraftError', null);
    case constants.DISCARD_DRAFT_PPSI_DONE:
      return state
        .set('isdiscardingDraft', false)
        .set(
          'ppsis',
          payload !== '' ? mergePpsis(state, [payload]) : removePpsi(state)
        );
    case constants.DISCARD_DRAFT_PPSI_FAIL:
      return state
        .set('isdiscardingDraft', false)
        .set('discardDraftError', fromJS(payload));

    // PPSI send for global review
    case constants.SUBMIT_FOR_REVIEW_PPSI:
      return state.set('isSendingForReview', true).set('sendReviewError', null);
    case constants.SUBMIT_FOR_REVIEW_PPSI_DONE:
      return state
        .set('ppsis', mergePpsis(state, [payload]))
        .set('isSendingForReview', false);
    case constants.SUBMIT_FOR_REVIEW_PPSI_FAIL:
      return state
        .set('sendReviewError', fromJS(payload))
        .set('isSendingForReview', false);

    // get PPSI with global status in local market
    case constants.FETCH_GLOBAL_STATUS_PPSIS:
      return state
        .set('isFetchingGlobalStatus', true)
        .set('globalStatusError', null);
    case constants.FETCH_GLOBAL_STATUS_PPSIS_DONE:
      return state
        .set('globalStatusPpsis', fromJS(payload))
        .set('isFetchingGlobalStatus', false);
    case constants.FETCH_GLOBAL_STATUS_PPSIS_FAIL:
      return state
        .set('globalStatusError', fromJS(payload))
        .set('isFetchingGlobalStatus', false);

    // get total range static report.
    case constants.FETCH_TOTAL_RANGE_REPORT:
      return state
        .set('isFetchingRangeReport', true)
        .set('rangeReportError', null);
    case constants.FETCH_TOTAL_RANGE_REPORT_DONE:
      return state
        .set('totalRangeReport', fromJS(payload))
        .set('isFetchingRangeReport', false);
    case constants.FETCH_TOTAL_RANGE_REPORT_FAIL:
      return state
        .set('rangeReportError', fromJS(payload))
        .set('isFetchingRangeReport', false);

    // get Co-worker Engagement report.
    case constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT:
      return state
        .set('isFetchingEngagementReport', true)
        .set('engagementReportError', null);
    case constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_DONE:
      return state
        .set('totalEngagementReport', fromJS(payload))
        .set('isFetchingEngagementReport', false);
    case constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_FAIL:
      return state
        .set('engagementReportError', fromJS(payload))
        .set('isFetchingEngagementReport', false);

    // get Co-worker Engagement report Market List.
    case constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST:
      return state
        .set('isFetchingEngagementReportMarketList', true)
        .set('engagementReportMarketListError', null);
    case constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_DONE:
      return state
        .set('totalEngagementReportMarketList', fromJS(payload))
        .set('isFetchingEngagementReportMarketList', false);
    case constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST_FAIL:
      return state
        .set('engagementReportMarketListError', fromJS(payload))
        .set('isFetchingEngagementReportMarketList', false);

    // fetch review PPSI and filter with status
    case constants.FETCH_REVIEW_PPSIS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_REVIEW_PPSIS_DONE:
      return state
        .set('reviewPpsis', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.FETCH_REVIEW_PPSIS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    // fetch PPSI review summary
    case constants.FETCH_PPSIS_REVIEW_SUMMARY:
      if (payload) {
        return state.set('reviewSummaryError', null);
      }
    case constants.NAVIGATE_TO_REVIEW_DONE:
      return state
        .set('reviewMarketCount', payload)
        .set('isFetchingReviewSummary', false);

    case constants.FETCH_PPSIS_REVIEW_SUMMARY_DONE:
      if (payload.conditionCheck) {
        return state.set('isFetchingReviewSummary', false);
      }
      return state
        .set('ppsisReviewSummary', fromJS(payload.ppsis))
        .set('reviewSummaryError', null)
        .set('isFetchingReviewSummary', false);

    case constants.FETCH_PPSIS_REVIEW_SUMMARY_FAIL:
      return state
        .set('reviewSummaryError', fromJS(payload))
        .set('isFetchingReviewSummary', false);

    // fetch PPSIs for global approval
    case constants.FETCH_GLOBAL_APPROVAL_PPSI:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_GLOBAL_APPROVAL_PPSI_DONE:
      return state
        .set('globalApprovalPpsis', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.FETCH_GLOBAL_APPROVAL_PPSI_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    // global approve PPSIs
    case constants.GLOBAL_APPROVE_REVIEW_PPSI:
      return state
        .set('isglobalApproving', true)
        .set('globalApproveError', null);
    case constants.GLOBAL_APPROVE_REVIEW_PPSI_DONE:
      return state
        .set('globalApprovalPpsis', fromJS(payload))
        .set('globalApproveError', null)
        .set('isglobalApproving', false)
        .set('hasRecalledError', false);
    case constants.GLOBAL_APPROVE_REVIEW_PPSI_FAIL:
      return state
        .set('globalApproveError', fromJS(payload))
        .set('isglobalApproving', false);

    // global reject PPSIs
    case constants.GLOBAL_REJECT_REVIEW_PPSI:
      return state
        .set('isglobalRejecting', true)
        .set('globalRejectError', null);
    case constants.GLOBAL_REJECT_REVIEW_PPSI_DONE:
      return state
        .set('globalApprovalPpsis', fromJS(payload))
        .set('globalRejectError', null)
        .set('hasRecalledError', false)
        .set('isglobalRejecting', false);
    case constants.GLOBAL_REJECT_REVIEW_PPSI_FAIL:
      return state
        .set('globalRejectError', fromJS(payload))
        .set('isglobalRejecting', false);

    // Uploading BOM report for NIR markets
    case constants.UPLOAD_BOM_REPORT_RESET:
      return state
        .set('isBomReportUploading', false)
        .set('bomReportUploadError', null)
        .set('bomReportUploadSuccess', null);

    case constants.UPLOAD_BOM_REPORT:
      return state
        .set('isBomReportUploading', true)
        .set('bomReportUploadError', null)
        .set('bomReportUploadSuccess', null);

    case constants.UPLOAD_BOM_REPORT_SUCCESS:
      return state
        .set('isBomReportUploading', false)
        .set('bomReportUploadError', null)
        .set('bomReportUploadSuccess', fromJS(payload));

    case constants.UPLOAD_BOM_REPORT_FAILURE:
      return state
        .set('isBomReportUploading', false)
        .set('bomReportUploadError', fromJS(payload))
        .set('bomReportUploadSuccess', null);

    // Fetch global PPSI:s (non market specific) for NIR
    case constants.FETCH_GLOBAL_PPSIS_NIR:
      return state
        .set('isFetching', true)
        .set('globalPublishedPpsiNirError', null);

    case constants.FETCH_GLOBAL_PPSIS_NIR_DONE:
      return state
        .set('isFetching', false)
        .set('fetchError', null)
        .set('globalPublishedPpsisNir', fromJS(payload));

    case constants.FETCH_GLOBAL_PPSIS_NIR_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    case constants.FETCH_RA_PA_NIR:
      return (
        state
          // .set('isFetching', true)
          .set('paRaNirError', null)
      );
    case constants.FETCH_RA_PA_NIR_DONE:
      return state.set('piaProductAreas', fromJS(payload));
    // .set('isFetching', false)
    // .set('fetchError', null)
    // .set('paRaNirError', fromJS(payload));
    case constants.FETCH_RA_PA_NIR_FAIL:
      return state.set('fetchError', fromJS(payload));

    case constants.HAS_RECALLED_PPSI_ERROR:
      return state.set('hasRecalledError', payload).set('isFetching', false);

    case constants.FETCH_RECALLED_ERROR_ONE:
      return state.set('isFetching', false);
    case constants.FETCH_RECALLED_ERROR_ONE_DONE:
      return state.set('recalledStatus', payload).set('isFetching', false);
    case constants.FETCH_RECALLED_ERROR_ONE_FAIL:
      return state.set('isFetching', false);

    // Create Local Global NIR PPSI from dish
    case constants.CREATE_PPSI_FROM_GLOBAL_NIR:
      return state
        .set('isSaving', true)
        .set('saveError', null)
        .set('lastSavedPpsiId', null);

    // PPSI discard draft NIR
    case constants.DISCARD_DRAFT_PPSI_NIR:
      return state
        .set('isdiscardingDraft', true)
        .set('discardDraftError', null);

    // PPSI delete Nir
    case constants.DELETE_PPSI_NIR:
      return state.set('isFetching', true).set('fetchDeleteError', null);

    case constants.APPROVE_PPSI_NIR:
      return state.set('isApproving', true).set('approveError', null);

    // Fetch global PPi IFS Market for local market
    case constants.FETCH_GLOBAL_PPI_IFS:
      return state
        .set('isFetching', true)
        .set('globalPublishedPpiIfsError', null);

    case constants.FETCH_GLOBAL_PPI_IFS_DONE:
      return state
        .set('isFetching', false)
        .set('fetchError', null)
        .set('globalPublishedPpiIfs', fromJS(payload));

    case constants.FETCH_GLOBAL_PPI_IFS_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    case constants.SET_PPSI_ID:
      return state.set('ppsiId', payload);

    case constants.SHOW_POP_UP:
      return state.set('show', payload);

    //Fetch Market Dish Logo
    case constants.FETCH_MARKET_DISH_LOGO:
      return state.set('isFetchingDishLogo', true).set('fetchError', null);

    case constants.FETCH_MARKET_DISH_LOGO_DONE:
      return state
        .set('isFetchingDishLogo', false)
        .set('fetchError', null)
        .set('marketDishLogo', fromJS(payload));
    case constants.FETCH_MARKET_DISH_LOGO_FAIL:
      return state
        .set('isFetchingDishLogo', false)
        .set('fetchError', fromJS(payload));

    case constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS:
      return state.set('isFetchingCopyLocal', true).set('fetchError', null);

    case constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS_DONE:
      return state
        .set('isFetchingCopyLocal', false)
        .set('fetchError', null)
        .set('publishedUnpublishedPpsis', fromJS(payload));

    case constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS_FAIL:
      return state
        .set('isFetchingCopyLocal', false)
        .set('fetchError', fromJS(payload));

    case constants.IS_ENABLE_AVAILABLITY:
      return state.set('isEnableAvailablity', payload);
    default:
      return state;
  }
}
